'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresOmalomaMessagesController = function () {
  function WinresOmalomaMessagesController($rootScope, $scope, omalomaService, $location, $timeout) {
    _classCallCheck(this, WinresOmalomaMessagesController);

    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.omalomaService = omalomaService;
    this.$location = $location;
    this.$timeout = $timeout;

    // Current status. Possible values:
    // init - Initializing.
    // out - Not logged in.
    // waiting_for_parameter - Waiting for a dynamic parameter to be set.
    // loading - Loading info.
    // ready - Info loaded.
    // error - Failed to load info.
    this.setStatus('init', null);

    this.locationParameterMsg = this.$location.search().msg;
    console.log("[WOM] locationParameterMsg 'booking' is: ", this.locationParameterMsg);
  }

  _createClass(WinresOmalomaMessagesController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.$rootScope.$on('login', function () {
        return _this.setStatus('in', null);
      });
      this.$rootScope.$on('logout', function () {
        return _this.setStatus('out', null);
      });
      //this.$scope.$watch(() => this.bookingNumber, () => this.load());

      // Go to payment tab.
      if (this.$location.search().payment > -1) {
        this.$location.search('payment', null);
        // "Maksa" tab.
        this.$timeout(function () {
          return _this.goToPaymentTab();
        }, 5000);
        //this.$timeout(() => document.querySelector("[href*=tab-1493036671149-3-9]").parentNode.click(), 6000);
        return;
      }

      if (this.locationParameterMsg) {
        this.setStatus(this.locationParameterMsg, null);
        if (this.locationParameterMsg.search(/paymentcancel|paymentreject/g) > -1) {
          // this.$location.search('msg', null);
          // this.$location.search('ORDER_NUMBER', null);
          // this.$location.search('TIMESTAMP', null);
          // this.$location.search('RETURN_AUTHCODE', null);

          var bookingNumber = this.$location.search().booking;

          // clear all params from href and add payment and booking number.
          window.location.href = window.location.href.replace(/\?.*/, '#!?payment&booking=' + bookingNumber);
        }
      } else {
        this.setStatus('out', null);
      }
    }
  }, {
    key: 'setStatus',
    value: function setStatus(status, error) {
      this.$scope.status = status;
      console.log('[WOM] Set status to', status);
      if (error !== undefined) {
        if (error) console.log('[WOM] Error:', error);
        this.$scope.error = error;
      }
    }
  }, {
    key: 'clearMessageParameter',
    value: function clearMessageParameter() {
      // remove the ?msg= parameter from url and change the status so that modal disappears
      this.$location.search('msg', null);
      this.setStatus('ready', null);
    }
  }, {
    key: 'goToPaymentTab',
    value: function goToPaymentTab() {
      //document.querySelectorAll("a[href='#tab-1493036671149-3-9']")[0].click();
      var tabID = angular.element('winres-omaloma-pay').closest('.tab-content').attr('id');
      document.querySelector('a[href="#' + tabID + '"]').click();
    }
  }]);

  return WinresOmalomaMessagesController;
}();

WinresOmalomaMessagesController.$inject = ['$rootScope', '$scope', 'omalomaService', '$location', '$timeout'];

_module3.default.component('winresOmalomaMessages', {
  template: require('./winresOmalomaMessages.html'),
  controller: WinresOmalomaMessagesController,
  require: {},
  bindings: {
    bookingNumber: '<'
  }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresOmalomaMessages/winresOmalomaMessages.js
// module id = 361
// module chunks = 2